import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "user-information" }
const _hoisted_2 = { class: "user-heading" }
const _hoisted_3 = { class: "user-name" }
const _hoisted_4 = { class: "user-name" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "user-links-box" }
const _hoisted_7 = { class: "user-links" }
const _hoisted_8 = { class: "user-links" }

import ModalTopRight from '@/design-system/templates/ModalTopRight.vue'
import DropdownStandard from '@/design-system/molecules/DropdownStandard.vue'
import ContainerLogo from '@/design-system/atoms/ContainerLogo.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import i18n from '@/i18n'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { postUserLanguage } from '@/services/realms.service'
import { clearLocalStorage } from '@/utils/localstorage'
import { getRealmId } from '@/utils/realmId'
interface EMITS {
  (e: 'closeMenu')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MenuUserSettingsCard',
  emits: ["closeMenu"],
  setup(__props, { emit: __emit }) {

const store = useStore()
const { t } = useI18n()

const emits = __emit

const languageOptions = ref<any>([
  {
    disabled: false,
    id: 'sv',
    name: t('general__language__swedish'),
    selected: false,
    value: 1
  },
  {
    disabled: false,
    id: 'en',
    name: t('general__language__english'),
    selected: false,
    value: 2
  }
])

const i18nLanguage = computed(() => i18n.global.locale.value)
const initialLoad = ref<boolean>(true)
const emailOfCurrentUser = computed<string>(() => store.state.oidcStore?.user?.preferred_username)
// sub (subject) equals userId
const idOfCurrentUser = computed<string>(() => store.state.oidcStore?.user?.sub)
const languageOptionsTitle = computed(() => {
  const currentLanguage = languageOptions.value.find((language) => language.selected)
  return currentLanguage?.name ? currentLanguage.name : ''
})

const modalUserSettings = ref<HTMLElement | null>(null)
const nameOfCurrentUser = computed<string>(() => store.state.oidcStore?.user?.name)
const realmId = computed(() => getRealmId())
const realmLogo = computed<string>(() => store.getters.realmLogo)

function closeMenu(event: MouseEvent | TouchEvent) {
  if (initialLoad.value) {
    initialLoad.value = false
    return
  }
  const target = event.target as HTMLElement
  if (!modalUserSettings.value?.contains(target)) {
    emits('closeMenu')
  }
}
function handleLanguageSelection(selectedValue) {
  if (!realmId.value) return
  if (selectedValue !== i18nLanguage.value) {
    postUserLanguage(realmId.value, idOfCurrentUser.value, selectedValue)
    i18n.global.locale.value = selectedValue
    store.commit('setInfoMessage', {
      type: 'success',
      message: t('message__language-changed')
    })
  }
}
function handleSupport() {
  window.open('mailto: support@digitalbuildings.ai?subject=ZDB support')
}
function signOut() {
  const id_token = store.state.oidcStore.id_token
  clearLocalStorage()
  store.dispatch('signOutOidc', { id_token_hint: id_token })
}
onMounted(() => {
  document.addEventListener('click', closeMenu)
  languageOptions.value.forEach((language) => {
    if (language.id === i18nLanguage.value) language.selected = true
  })
})
onUnmounted(() => document.removeEventListener('click', closeMenu))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTopRight, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "modalUserSettings",
        ref: modalUserSettings,
        class: "user-settings-modal"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["user-information-box", { 'user-information-box-no-logo': !realmLogo.value.length }])
        }, [
          (realmLogo.value.length)
            ? (_openBlock(), _createBlock(ContainerLogo, {
                key: 0,
                class: "logo-position",
                "logo-src": realmLogo.value
              }, null, 8, ["logo-src"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('general__text__user')), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(nameOfCurrentUser.value ? nameOfCurrentUser.value : ''), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(emailOfCurrentUser.value ? emailOfCurrentUser.value : ''), 1)
          ])
        ], 2),
        _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "divider" }, null, -1)),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('general__text__language-settings')), 1),
        _createVNode(DropdownStandard, {
          class: "dropdown",
          title: languageOptionsTitle.value,
          options: languageOptions.value,
          onSelect: handleLanguageSelection
        }, null, 8, ["title", "options"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ButtonText, {
              buttonText: _unref(t)('general__text__support'),
              iconLeft: require(`@/design-system/assets/icons/Icon-Mail.svg`),
              size: "small",
              onOnClicked: handleSupport
            }, null, 8, ["buttonText", "iconLeft"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(ButtonText, {
              buttonText: _unref(t)('general__text__logout'),
              iconLeft: require(`@/design-system/assets/icons/Icon-Log-Out.svg`),
              size: "small",
              onOnClicked: signOut
            }, null, 8, ["buttonText", "iconLeft"])
          ])
        ])
      ], 512)
    ]),
    _: 1
  }))
}
}

})